import { useMemo } from 'react'
import { match } from 'ts-pattern'

import { useTranslation } from '@root/shared/localization'

import type {
  InsufficientBalanceError,
  NoAmountError,
} from '@root/features/trade/validation-errors'

export const useTradingControlsValidation = (
  validation: InsufficientBalanceError | NoAmountError | undefined,
) => {
  const { t } = useTranslation()

  const validationMessage = useMemo(
    () =>
      match(validation)
        .with({ _tag: 'InsufficientBalance' }, (validation) =>
          t('trading.error.insufficient-funds', {
            ticker: validation.currency?.ticker,
          }),
        )
        .with({ _tag: 'NoAmount' }, () => t('trading.error.no-amount'))
        .otherwise(() => undefined),
    [t, validation],
  )

  return { validationMessage }
}
